import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-cream" data-id="element-121">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-122">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-sage-light rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-123"></div>
        <div className="absolute top-1/2 -right-24 w-80 h-80 bg-gold-light rounded-full mix-blend-multiply filter blur-3xl opacity-40" data-id="element-124"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 max-w-6xl" data-id="element-125">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-126">
          <div className="flex-1 text-center lg:text-left" data-id="element-127">
            <FadeIn data-id="element-128">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-forest leading-tight mb-6" data-id="element-129">
                Perimenopausia:{' '}
                <span className="text-sage" data-id="element-130">Entiende, Ajusta, Mejora</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-131">
              <h2 className="text-xl md:text-2xl text-forest/80 font-medium mb-8 leading-relaxed" data-id="element-132">
                El manual de supervivencia para recuperar tu energía,
                desinflamar tu abdomen y volver a reconocer tu cuerpo en 21
                días.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-133">
              <div className="prose prose-lg text-forest/70 mb-10 mx-auto lg:mx-0" data-id="element-134">
                <p data-id="element-135">
                  Te despiertas a las 3 de la mañana con la mente acelerada y el
                  cuerpo empapado en sudor. Unas horas después, frente al
                  espejo, notas que tus pantalones favoritos ya no cierran, a
                  pesar de que "comes igual que siempre".
                </p>
                <p data-id="element-136">
                  No es tu falta de voluntad. No es que te hayas vuelto
                  perezosa. Es que las reglas de tu metabolismo cambiaron y
                  nadie te dio el nuevo manual de instrucciones.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.6} data-id="element-137">
              <Button href="#offer" data-id="element-138">DESCARGAR MI MANUAL AHORA</Button>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none" data-id="element-139">
            <FadeIn direction="left" delay={0.3} data-id="element-140">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-141">
                <img src="https://cdn.magicpatterns.com/uploads/rPbPHXLtSxHPNWmWzEgWo7/heylloyd-image-1777120197768.png" alt="Perimenopausia: Entiende, Ajusta, Mejora - Mockups del producto" className="w-full h-auto object-cover" data-id="element-142" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}